export var TableRole;
(function (TableRole) {
    TableRole["Table"] = "table";
    TableRole["Body"] = "tableBody";
    TableRole["Row"] = "tableRow";
    TableRole["Cell"] = "tableCell";
})(TableRole || (TableRole = {}));
